<template>
  <side :nav="nav"></side>
</template>

<script>
import side from "../side";
import role from "../../mixins/role";
export default {
  mixins: [role],
  data() {
    return {
      nav: [
        { name: "我的上传", url: "myUpload" },
        { name: "我的收藏", url: "myCollection" },
        { name: "我的下载", url: "myDownload" },
        { name: "送印记录", url: "myPrinting" },
      ],
    };
  },
  components: { side },
  methods: {
    init() {
      if (this.userModule.role == "AreaManager") {
        this.nav = [
          { name: "我的上传", url: "myUpload" },
          { name: "我的收藏", url: "myCollection" },
          { name: "我的下载", url: "myDownload" },
        ];
      } else {
        this.nav = [
          { name: "我的上传", url: "myUpload" },
          { name: "我的收藏", url: "myCollection" },
          { name: "我的下载", url: "myDownload" },
          { name: "送印记录", url: "myPrinting" },
        ];
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/my/index.vue